export default ((window, document, undefined) => {

  'use strict';

  window.InputDropdown = function() {
    function init(select) {
      const parent = select.parentElement;
      const options = select.querySelectorAll('option');
      const config = select.dataset.inputDropdown && JSON.parse(select.dataset.inputDropdown);

      const id = select.id ? `${select.id}--input-dropdown` : `input-dropdown--${Math.random().toString(36).substring(2, 12)}`

      const dropdown = document.createElement('div');
      dropdown.className = 'dropdown';

      const toggle = document.createElement('button');
      toggle.dataset.bsToggle = 'dropdown';
      toggle.ariaExpanded = false;
      toggle.role = 'button';
      toggle.id = id;

      const caption = document.createElement('span');
      caption.className = 'caption';
      toggle.appendChild(caption);

      const captionText = document.createElement('span');
      captionText.className = 'caption__text text-truncate';
      caption.innerHTML = select.options[ select.selectedIndex ].text;
      caption.appendChild(captionText);

      if (config.toggleIcon) {
        const i = document.createElement('i');
        i.className = 'base-icon';
        i.innerHTML = `<svg class="icon" preserveAspectRatio="xMaxYMin"><use xlink:href="${config.toggleIcon.src}#icon-${config.toggleIcon.symbol}"></use></svg>`;
        toggle.appendChild(i);
      }

      dropdown.appendChild(toggle);

      const ul = document.createElement('ul');
      ul.className = 'dropdown-menu';
      ul.setAttribute('aria-labelledby', id);

      const items = Array.from(options).map((option, index) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'dropdown-item';
        a.dataset.value = option.value;
        a.innerHTML = option.text;
        a.dataset.index = index;

        li.appendChild(a);
        ul.appendChild(li);
      });

      dropdown.appendChild(ul);

      parent.addEventListener('click', selectItem);

      select.addEventListener('change', updateDisplay);

      parent.appendChild(dropdown);

      // document.addEventListener('click', (event) => {
      //   const target = event.target;
      //   if (target.closest('[data-bs-toggle]')) {
      //     if (ul.classList.contains('show')) {
      //       hide(ul);
      //     }
      //     else {
      //       show(ul);
      //     }
      //   }
      // });

      // document.addEventListener('click', (event) => {
      //   const target = event.target;
      //   if (! target.closest('.dropdown')) {
      //     hide(ul);
      //   }
      // });

      const hiddenElements = [ select, select.parentElement.querySelector('.input__label') ];
      hiddenElements.forEach(element => {
        element.classList.add('visually-hidden');
      });
    }

    function selectItem(event) {
      if (event.target.closest('.dropdown-item')) {
        event.preventDefault();
        // event.stopPropagation();
        // event.stopImmediatePropagation();

        const parent = event.target.closest('.input--dropdown');
        const select = parent.querySelector('select');

        // todo: check object feasability
        select.value = event.target.dataset.value;

        const changeEvent = new Event('change');
        select.dispatchEvent(changeEvent);
      }
    }

    function updateDisplay(event) {
      const parent = event.target.closest('.input--dropdown');
      const select = parent.querySelector('select');
      const caption = parent.querySelector('.dropdown .caption');
      caption.innerHTML = select.options[ select.selectedIndex ].text;
    }

    function show(ul) {
      ul.classList.add('show');
    }

    function hide(ul) {
      ul.classList.remove('show');
    }

    return {
      init: (() => {
        window.addEventListener('DOMContentLoaded', () => {
          const selects = document.querySelectorAll( 'select[data-input-dropdown]' );
          Array.from(selects).forEach(select => {
            if (! select.dataset.initialized) {
              init(select);
              select.dataset.initialized = true;
            }
          });
        });
      })()
    };
  };

  InputDropdown();

})( window, document );
